import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=0b6fc0be&scoped=true&"
import script from "./ChannelList.vue?vue&type=script&lang=js&"
export * from "./ChannelList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=0b6fc0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6fc0be",
  null
  
)

export default component.exports